export type RequestReasonEnum = 'OVERTIME' | 'HOURS_JUSTIFICATION';

export const RequestReasonEnumValues = {
    Overtime: 'OVERTIME' as RequestReasonEnum,
    HoursJustification: 'HOURS_JUSTIFICATION' as RequestReasonEnum,
};
